<template>
    <div>
        <v-row class="mb-3 mx-1">
            <div :class="{ 'pt-1': true, 'pl-3': $vuetify.breakpoint.smAndUp, 'pl-2': $vuetify.breakpoint.xsOnly }">
                <span v-if="fileDetail" class="gray--text" style="font-size:16px;">
                    <b>{{ $t('Дата последнего обновления') }}:</b>
                    {{ fileDetail.preview_data_date | formatDateFull }}
                </span>
            </div>
            <div class="pt-1 d-flex justify-start">
                <Tooltip maxWidth="800" :text="$t('uploadsTooltipTextGrouped', { date: formatFileDate(fileDetail.preview_data_date) })">
                    <template v-slot:item>
                        <span
                            v-if="status === 'Загружен' && userPermissions.includes('updateGroupedData')"
                            @click="refreshData"
                            :class="{ 'ml-9': $vuetify.breakpoint.smAndUp, 'ml-2': $vuetify.breakpoint.xsOnly }"
                        >
                            <v-icon class="pointer info--text">mdi-table-refresh</v-icon>
                        </span>
                    </template>
                </Tooltip>
                <TipInfo v-if="status === 'Загружен'" :date="fileDetail.preview_data_date | formatDateFull" text="uploadsTooltipTextGrouped" />
            </div>
            <v-spacer></v-spacer>

            <PreviewDataFilter @filter="filterItems" :customDisable="customDisable" :value="previewGroupedDataFilter" @saveFilter="saveFilterData" />
        </v-row>
        <!-- <div class="grouped-data"> -->
        <div class="grouped-data">
            <div class="uploads-table">
                <v-data-table
                    id="previw-file"
                    height="600"
                    :headers="headers"
                    :items="groupedData"
                    :server-items-length="groupedDataLength"
                    :options.sync="groupedDataPagination"
                    :loading="groupedDataLoading"
                    :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
                    ref="table"
                >
                    <template v-slot:item.meter_rid="{ item }">
                        <table-cell-tooltip :header="headers[0]" :item="item">
                            <span>{{ item.meter_rid }}</span>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.meter_number="{ item }">
                        <table-cell-tooltip :header="headers[1]" :item="item">
                            <span>{{ item.meter_number }}</span>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.date_consumption_begin="{ item }">
                        <table-cell-tooltip :header="headers[2]" :item="item" filter="formatDate">
                            <span>{{ item.date_consumption_begin | formatDate }}</span>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.date_consumption_end="{ item }">
                        <table-cell-tooltip :header="headers[3]" :item="item" filter="formatDate">
                            <span>{{ item.date_consumption_end | formatDate }}</span>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.error_text="{ item }">
                        <table-cell-tooltip :header="headers[4]" :item="item">
                            <span>{{ item.error_text }}</span>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.temperature_in="{ item }">
                        <table-cell-tooltip :header="headers[5]" :item="item" filter="formatDecimal">
                            <div class="number-cell">{{ item.temperature_in | formatDecimal }}</div>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.temperature_out="{ item }">
                        <table-cell-tooltip :header="headers[6]" :item="item" filter="formatDecimal">
                            <div class="number-cell">{{ item.temperature_out | formatDecimal }}</div>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.water_weight_on_gvs="{ item }">
                        <table-cell-tooltip :header="headers[7]" :item="item" filter="formatDecimal">
                            <div class="number-cell">{{ item.water_weight_on_gvs | formatDecimal }}</div>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.water_weight_in="{ item }">
                        <table-cell-tooltip :header="headers[8]" :item="item" filter="formatDecimal">
                            <div class="number-cell">{{ item.water_weight_in | formatDecimal }}</div>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.water_weight_out="{ item }">
                        <table-cell-tooltip :header="headers[9]" :item="item" filter="formatDecimal">
                            <div class="number-cell">{{ item.water_weight_out | formatDecimal }}</div>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.heat_energy_all="{ item }">
                        <table-cell-tooltip :header="headers[10]" :item="item" filter="formatDecimal">
                            <div class="number-cell">{{ item.heat_energy_all | formatDecimal }}</div>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.temp_cold_water="{ item }">
                        <table-cell-tooltip :header="headers[11]" :item="item" filter="formatDecimal">
                            <div class="number-cell">{{ item.temp_cold_water | formatDecimal }}</div>
                        </table-cell-tooltip>
                    </template>
                    <template v-slot:item.work_time="{ item }">
                        <table-cell-tooltip :header="headers[12]" :item="item" filter="formatDecimal">
                            <div class="number-cell">{{ item.work_time | formatDecimal }}</div>
                        </table-cell-tooltip>
                    </template>
                </v-data-table>
                <table-arrows :table="$refs.table"></table-arrows>
            </div>
        </div>
        <!-- </div> -->
    </div>
</template>

<script>
import TipInfo from './TipInfo';
import PreviewDataFilter from './PreviewDataFilter';
import Tooltip from '@/components/ui/Tooltip';
import TableCellTooltip from '@/components/ui/TableCellTooltip';
import TableArrows from '@/components/ui/TableArrows';
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import { isFilterEmpty } from '@/utils';

export default {
    props: ['id', 'status'],
    components: {
        TipInfo,
        PreviewDataFilter,
        Tooltip,
        TableCellTooltip,
        TableArrows
    },
    data: () => ({
        resetFilter: false,
        theFilter: {}
    }),
    watch: {
        groupedDataPagination: function() {
            this.getGroupedData(this.id);
        }
    },
    async mounted() {
        this.$watch(
            '$vuetify.breakpoint.xsOnly',
            (newVal, oldVal) => {
                if (newVal === oldVal) {
                    return;
                }
                if (newVal) {
                    this.groupedDataPagination.itemsPerPage = 1;
                }
                if (oldVal) {
                    this.groupedDataPagination.itemsPerPage = 10;
                }
                this.groupedDataPagination.page = 1;
            },
            { immediate: true }
        );
        this.getGroupedData(this.id);
    },
    computed: {
        ...mapState('permissions', ['userPermissions']),
        ...mapState('uploads', ['fileDetail', 'groupedData', 'groupedDataLoading', 'groupedDataLength', 'groupedDataFilter']),
        groupedDataPagination: {
            get() {
                return this.$store.state.uploads.groupedDataPagination;
            },
            set(val) {
                this.$store.commit('uploads/setGroupedDataPagination', val);
            }
        },
        previewGroupedDataFilter: {
            get() {
                return this.$store.state.uploads.groupedDataUnformattedFilter;
            },
            set(val) {
                this.$store.commit('uploads/setGroupedDataUnformattedFilter', val);
            }
        },
        customDisable() {
            return isFilterEmpty(this.previewGroupedDataFilter);
        },
        headers() {
            return [
                {
                    text: this.$t('ID номер ПУТЭ'),
                    value: 'meter_rid',
                    width: '2%'
                },
                {
                    text: this.$t('Заводской номер ПУТЭ') + '  ',
                    value: 'meter_number',
                    width: '3%'
                },
                {
                    text: this.$t('Дата начала'),
                    value: 'date_consumption_begin',
                    width: '1%'
                },
                {
                    text: this.$t('Дата окончания'),
                    value: 'date_consumption_end',
                    width: '4%'
                },
                {
                    text: this.$t('Статус загрузки'),
                    value: 'error_text',
                    width: '5%'
                },
                {
                    text: this.$t('Температура ПВ (С)'),
                    value: 'temperature_in',
                    width: '1%'
                },
                {
                    text: this.$t('Температура ОВ (С)'),
                    value: 'temperature_out',
                    width: '1%'
                },
                {
                    text: this.$t('Масса воды на ГВС'),
                    value: 'water_weight_on_gvs',
                    width: '4%'
                },
                {
                    text: this.$t('Масса воды в ПВ'),
                    value: 'water_weight_in',
                    width: '4%'
                },
                {
                    text: this.$t('Масса воды в ОВ'),
                    value: 'water_weight_out',
                    width: '3%'
                },
                {
                    text: this.$t('Теплоэнергия общая'),
                    value: 'heat_energy_all',
                    width: '1%'
                },
                {
                    text: this.$t('Температура Хол. воды'),
                    value: 'temp_cold_water',
                    width: '1%'
                },
                {
                    text: this.$t('Рабочее время (ч)'),
                    value: 'work_time',
                    width: '1%'
                }
            ];
        }
    },
    methods: {
        ...mapActions('uploads', ['getGroupedData', 'previewFile', 'getFileDetail']),
        async refreshData() {
            let response = await this.previewFile(this.$route.params.id);
            await this.getGroupedData(this.id);
            await this.getFileDetail(this.$route.params.id);
        },
        async filterItems(val) {
            this.$store.commit('uploads/setGroupedDataFilter', val);
            await this.getGroupedData(this.id);
        },
        clearFilter() {
            this.resetFilter = true;
            this.$store.commit('uploads/setGroupedDataFilter', null);
            setTimeout(() => {
                this.resetFilter = false;
            }, 500);
        },
        saveFilterData(val) {
            this.previewGroupedDataFilter = val;
        },
        formatFileDate(date) {
            return moment(String(date)).format('DD.MM.YYYY HH:mm');
        }
    }
};
</script>
